module.exports = __webpack_public_path__ + "static/media/polskie_radio_100_lat.b11304ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/polskie_radio_100_lat.svg
// module id = 647
// module chunks = 0